/** Utilitários para cadeia Tipo / Subtipo 1–3 (espelha canais e backend). */

export function asNumOrNull(value) {
  if (value == null || value === "") return null;
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : null;
}

export function emptyLeadTypeValue() {
  return { id_tipo: null, id_tipo1: null, id_tipo2: null, id_tipo3: null };
}

/** Lê valor a partir de chaves default_* ou transfer/handoff. */
export function leadTypesFromConfig(raw = {}, prefix = "default") {
  const p = prefix === "default" ? "default" : "";
  return {
    id_tipo: asNumOrNull(raw[`${p}${p ? "_" : ""}tipo_id`] ?? raw.tipo_id ?? raw.id_tipo),
    id_tipo1: asNumOrNull(raw[`${p}${p ? "_" : ""}tipo1_id`] ?? raw.tipo1_id ?? raw.id_tipo1),
    id_tipo2: asNumOrNull(raw[`${p}${p ? "_" : ""}tipo2_id`] ?? raw.tipo2_id ?? raw.id_tipo2),
    id_tipo3: asNumOrNull(raw[`${p}${p ? "_" : ""}tipo3_id`] ?? raw.tipo3_id ?? raw.id_tipo3),
  };
}

export function leadTypesFromComplaintsDefaults(skillConfig = {}) {
  return {
    id_tipo: asNumOrNull(skillConfig.default_tipo_id),
    id_tipo1: asNumOrNull(skillConfig.default_tipo1_id),
    id_tipo2: asNumOrNull(skillConfig.default_tipo2_id),
    id_tipo3: asNumOrNull(skillConfig.default_tipo3_id),
  };
}

export function complaintsDefaultsPatchFromLeadTypes(types = {}) {
  const t = types || {};
  return {
    default_tipo_id: t.id_tipo != null ? String(t.id_tipo) : "",
    default_tipo1_id: t.id_tipo1 != null ? String(t.id_tipo1) : "",
    default_tipo2_id: t.id_tipo2 != null ? String(t.id_tipo2) : "",
    default_tipo3_id: t.id_tipo3 != null ? String(t.id_tipo3) : "",
  };
}

export function lifecycleTransferTypesFromConfig(transfer = {}) {
  return {
    id_tipo: asNumOrNull(transfer.tipo_id),
    id_tipo1: asNumOrNull(transfer.tipo1_id),
    id_tipo2: asNumOrNull(transfer.tipo2_id),
    id_tipo3: asNumOrNull(transfer.tipo3_id),
  };
}

export function lifecycleTransferPatchFromLeadTypes(types = {}) {
  const t = types || {};
  return {
    tipo_id: t.id_tipo != null ? String(t.id_tipo) : "",
    tipo1_id: t.id_tipo1 != null ? String(t.id_tipo1) : "",
    tipo2_id: t.id_tipo2 != null ? String(t.id_tipo2) : "",
    tipo3_id: t.id_tipo3 != null ? String(t.id_tipo3) : "",
  };
}

export function titleOfType(node) {
  if (!node) return "";
  return node.titulo ?? node.title ?? node.nome ?? node.name ?? `#${node.id}`;
}
